import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { SocialFollow } from "@/components/ui/social-follow";
import { ThemeToggle } from "@/components/ui/theme-toggle";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-background to-muted/20 px-4 relative">
      <Helmet>
        <title>Page Not Found | OdyVoy</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to OdyVoy home to continue planning your next adventure." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      {/* Theme Toggle in top right */}
      <div className="absolute top-4 right-4 z-50">
        <ThemeToggle />
      </div>
      
      <SocialFollow position="top-left" />
      <SocialFollow position="bottom-right" />
      
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-4">Oops! Page not found</p>
        <a href="/" className="text-primary hover:text-primary/80 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
